module.exports = __webpack_public_path__ + "static/media/docs_unactive.7d8f2ca7.svg";